import React, { FC } from 'react';
import { Control, UseFormWatch } from 'react-hook-form';
import { ReportConfigDto } from '@thingslog/repositories';

interface ConsumptionReportSettingsFormProps {
  control: Control<ReportConfigDto>;
  watch: UseFormWatch<ReportConfigDto>;
}

const ConsumptionReportSettingsForm: FC<
  ConsumptionReportSettingsFormProps
> = (): React.ReactElement | null => {
  // No additional settings for consumption report
  return null;
};

export default ConsumptionReportSettingsForm;
